export default "__VITE_ASSET__CJxNtyQx__"